'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useRef, useState } from 'react';
import { MeetingDialog } from './MeetingDialog';
import { MeetingsContext } from './context';
import { sendGTMEvent } from '@next/third-parties/google';
import Script from 'next/script';
interface HubspotMeetingScriptProviderProps {
  children: React.ReactNode;
}
export function HubspotMeetingScriptProvider({
  children
}: HubspotMeetingScriptProviderProps) {
  const dialogsRef = useRef<Map<string, HTMLDialogElement> | null>(null);
  const [meetingLinks, setMeetingLinks] = useState<string[]>([]);
  const pathname = usePathname();
  function addMeetingLink(link: string) {
    if (!meetingLinks.includes(link)) {
      setMeetingLinks([...meetingLinks, link]);
    }
  }
  function getRefsMap() {
    if (!dialogsRef.current) {
      dialogsRef.current = new Map();
    }
    return dialogsRef.current;
  }
  function openDialog(id: string) {
    const map = getRefsMap();
    const dialogRef = map.get(id);
    sendGTMEvent({
      event: 'meeting_dialog_opened',
      meetingId: id
    });
    dialogRef?.showModal();
  }
  function closeDialog(id: string) {
    const map = getRefsMap();
    const dialogRef = map.get(id);
    dialogRef?.close();
  }

  // useEffect(() => {
  //   const cacheBuster = Math.round(Math.random() * 100)
  //   const script = document.createElement('script')

  //   script.src = `https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js?v=${cacheBuster}`
  //   script.async = true

  //   document.body.appendChild(script)

  //   return () => {
  //     document.body.removeChild(script)
  //   }
  // }, [pathname])

  //log close events
  useEffect(() => {
    const map = getRefsMap();
    function onClose(id: string) {
      return () => {
        sendGTMEvent({
          event: 'meeting_dialog_closed',
          value: id
        });
      };
    }
    meetingLinks.forEach(id => {
      const dialog = map.get(id);
      if (dialog) {
        dialog.addEventListener('close', onClose(id));
      }
    });
    return () => {
      meetingLinks.forEach(id => {
        const dialog = map.get(id);
        if (dialog) {
          dialog.removeEventListener('close', onClose(id));
        }
      });
    };
  }, [meetingLinks]);
  return <MeetingsContext.Provider value={{
    closeDialog,
    openDialog,
    addMeetingLink
  }}>
      {children}
      {meetingLinks.map(l => {
      return <MeetingDialog meetingLink={l} key={l} closeDialog={closeDialog} dialogRef={(node: HTMLDialogElement) => {
        const map = getRefsMap();
        if (node) {
          map.set(l, node);
        } else {
          map.delete(l);
        }
      }} />;
    })}
      <Script src="https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js" strategy="lazyOnload" />
    </MeetingsContext.Provider>;
}
export function MeetingScript() {}